import { render, staticRenderFns } from "./LicenciaAlcoholesEliminados.vue?vue&type=template&id=8a85419c&"
import script from "./LicenciaAlcoholesEliminados.vue?vue&type=script&lang=js&"
export * from "./LicenciaAlcoholesEliminados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports